'use client';

import { c as _c } from "react/compiler-runtime";
import CkEditorCSRRendererInner from '@/components/elementary/CkEditorRenderer/CkEditorCSRRendererInner';
import type { CkEditorRendererProps } from '@/components/elementary/CkEditorRenderer/types';
import { ErrorBoundary } from '@/components/elementary/ErrorBoundary';
import './CkEditorDefaultStyles.css';
import { useTranslations } from 'next-intl';

/**
 * Use this variant of the CkEditorRenderer whenever you are within the client context. That means you will need to validate that the entire
 * tree in which this component is being rendered.
 */
const CkEditorCSRRenderer = props => {
  const $ = _c(7);
  const t = useTranslations("CkEditorRenderer");
  let t0;
  if ($[0] !== t) {
    t0 = t("error");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <CkEditorCSRRendererInner {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <ErrorBoundary customErrorTitle={t0} hideReset={true}>{t1}</ErrorBoundary>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default CkEditorCSRRenderer;